<!-- 手工加价审核 -->
<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Pricing.Audit')"
    width="1100px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="price-dialog"
  >
    <div class="price-dialog-header">
      <div>
        <el-button no="onOK" type="primary" @click="onOK">{{ $t('Pricing.CONFIRM') }}</el-button>
        <el-button no="onReset" @click="onReset">{{ $t('Pricing.Reset') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Back') }}</el-button>
      </div>
    </div>
    <div class="" style="margin-left: 10px;">
      <el-checkbox no="approveAsync" :label="$t('Pricing.ApproveAsync')" style="margin-top: 10px;" />
      <div style="height:28px; display: flex; margin: 10px 0px; ">
        <span style="margin-top: 7px; margin-right: 10px;">{{ $t('Pricing.TariffRatingAtTheTimeOfMaintenance') }}</span>
        <cargo-advance-select
          no="level"
          :static-options="tiers"
          tag-name="label"
          tag-value="value"
          :default-value="price.level"
          :clearable="false"
          style="width: 200px"
          @parentCallBack="p=>{price.level=p.value}"
        />
      </div>
      <el-row style="text-align: center;color: blue;">
        <el-col :span="6" style="border: 1px solid transparent;" />
        <el-col :span="3">
          <label>20'</label>
        </el-col>
        <el-col :span="3">
          <label>40'</label>
        </el-col>
        <el-col :span="3">
          <label>40'HC</label>
        </el-col>
        <el-col :span="3">
          <label>20'NOR</label>
        </el-col>
        <el-col :span="3">
          <label>40'NOR</label>
        </el-col>
        <el-col :span="3">
          <label>45'</label>
        </el-col>
      </el-row>
      <el-row :style="price.level === '0' ? `pointer-events: none` : ``">
        <el-col :span="2">
          <el-checkbox no="cost" label="Cost" disabled checked />
        </el-col>
        <el-col :span="4">
          <el-radio-group v-model="price.costMarkupType" :disabled="price.level === '0'" no="costMarkupType">
            <el-radio no="markupBy" :label="true">{{ $t('Pricing.MarkupBy') }}</el-radio>
            <el-radio no="markupTo" :label="false">{{ $t('Pricing.MarkupTo') }}</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.cost20" :disabled="price.level === '0'" no="cost20" :min="-1000" :max="999999999.99" @blur="onBlur('cost20')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.cost40" :disabled="price.level === '0'" no="cost40" :min="-1000" :max="999999999.99" @blur="onBlur('cost40')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.costHC" :disabled="price.level === '0'" no="costHC" :min="-1000" :max="999999999.99" @blur="onBlur('costHC')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.cost20nor" :disabled="price.level === '0'" no="cost20nor" :min="-1000" :max="999999999.99" @blur="onBlur('cost20nor')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.cost40nor" :disabled="price.level === '0'" no="cost40nor" :min="-1000" :max="999999999.99" @blur="onBlur('cost40nor')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.cost45" :disabled="price.level === '0'" no="cost45" :min="-1000" :max="999999999.99" @blur="onBlur('cost45')" />
        </el-col>
      </el-row>
      <el-row class="row-top-5" :style="price.level === '1' ? `pointer-events: none` : ``">
        <el-col :span="2">
          <el-checkbox no="tier1" label="Tier 1" disabled checked />
        </el-col>
        <el-col :span="4">
          <el-radio-group v-model="price.oneMarkupType" :disabled="price.level === '1'" no="oneMarkupType">
            <el-radio no="markupBy" :label="true">{{ $t('Pricing.MarkupBy') }}</el-radio>
            <el-radio no="markupTo" :label="false">{{ $t('Pricing.MarkupTo') }}</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.one20" :disabled="price.level === '1'" no="one20" :min="-1000" :max="999999999.99" @blur="onBlur('one20')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.one40" :disabled="price.level === '1'" no="one40" :min="-1000" :max="999999999.99" @blur="onBlur('one40')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.oneHC" :disabled="price.level === '1'" no="oneHC" :min="-1000" :max="999999999.99" @blur="onBlur('oneHC')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.one20nor" :disabled="price.level === '1'" no="one20nor" :min="-1000" :max="999999999.99" @blur="onBlur('one20nor')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.one40nor" :disabled="price.level === '1'" no="one40nor" :min="-1000" :max="999999999.99" @blur="onBlur('one40nor')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.one45" :disabled="price.level === '1'" no="one45" :min="-1000" :max="999999999.99" @blur="onBlur('one45')" />
        </el-col>
      </el-row>
      <el-row class="row-top-5" :style="price.level === '2' ? `pointer-events: none` : ``">
        <el-col :span="2">
          <el-checkbox no="tier2" label="Tier 2" disabled checked />
        </el-col>
        <el-col :span="4">
          <el-radio-group v-model="price.twoMarkupType" :disabled="price.level === '2'" no="twoMarkupType">
            <el-radio no="markupBy" :label="true">{{ $t('Pricing.MarkupBy') }}</el-radio>
            <el-radio no="markupTo" :label="false">{{ $t('Pricing.MarkupTo') }}</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.two20" :disabled="price.level === '2'" no="two20" :min="-1000" :max="999999999.99" @blur="onBlur('two20')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.two40" :disabled="price.level === '2'" no="two40" :min="-1000" :max="999999999.99" @blur="onBlur('two40')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.twoHC" :disabled="price.level === '2'" no="twoHC" :min="-1000" :max="999999999.99" @blur="onBlur('twoHC')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.two20nor" :disabled="price.level === '2'" no="two20nor" :min="-1000" :max="999999999.99" @blur="onBlur('two20nor')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.two40nor" :disabled="price.level === '2'" no="two40nor" :min="-1000" :max="999999999.99" @blur="onBlur('two40nor')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.two45" :disabled="price.level === '2'" no="two45" :min="-1000" :max="999999999.99" @blur="onBlur('two45')" />
        </el-col>
      </el-row>
      <el-row class="row-top-5" :style="price.level === '99' ? `pointer-events: none` : ``">
        <el-col :span="2">
          <el-checkbox no="tier3" label="Tier 3" disabled checked />
        </el-col>
        <el-col :span="4">
          <el-radio-group v-model="price.threeMarkupType" :disabled="price.level === '99'" no="threeMarkupType">
            <el-radio no="markupBy" :label="true">{{ $t('Pricing.MarkupBy') }}</el-radio>
            <el-radio no="markupTo" :label="false">{{ $t('Pricing.MarkupTo') }}</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.three20" :disabled="price.level === '99'" no="three20" :min="-1000" :max="999999999.99" @blur="onBlur('three20')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.three40" :disabled="price.level === '99'" no="three40" :min="-1000" :max="999999999.99" @blur="onBlur('three40')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.threeHC" :disabled="price.level === '99'" no="threeHC" :min="-1000" :max="999999999.99" @blur="onBlur('threeHC')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.three20nor" :disabled="price.level === '99'" no="three20nor" :min="-1000" :max="999999999.99" @blur="onBlur('three20nor')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.three40nor" :disabled="price.level === '99'" no="three40nor" :min="-1000" :max="999999999.99" @blur="onBlur('three40nor')" />
        </el-col>
        <el-col :span="3">
          <el-input-number v-model="price.three45" :disabled="price.level === '99'" no="three45" :min="-1000" :max="999999999.99" @blur="onBlur('three45')" />
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>

import { approvePriceFclsWithAllTiers } from '@/api/price/priceFcl'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { getLoading } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'FclMarkupManualDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    isSpot: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      fullscreenLoading: null,
      tiers: PriceUtils.TIERS,
      price: {
        level: '0',
        isAsync: false,
        costMarkupType: true,
        oneMarkupType: true,
        twoMarkupType: true,
        threeMarkupType: true,
        cost20: 0,
        cost40: 0,
        costHC: 0,
        cost40nor: 0,
        cost20nor: 0,
        cost45: 0,
        one20: 0,
        one40: 0,
        oneHC: 0,
        one40nor: 0,
        one20nor: 0,
        one45: 0,
        two20: 0,
        two40: 0,
        twoHC: 0,
        two20nor: 0,
        two40nor: 0,
        two45: 0,
        three20: 0,
        three40: 0,
        threeHC: 0,
        three20nor: 0,
        three40nor: 0,
        three45: 0
      },
      selectedRowUuids: [],
      selectedRows: []
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  watch: {},
  methods: {
    setData(selectedRowUuids, selectedRows) {
      this.selectedRowUuids = selectedRowUuids
      this.selectedRows = selectedRows
      this.onReset()
    },
    async onOK() {
      if (this.isSpot) {
        let flag = false
        await this.$confirm(this.$t('Pricing.ECommerceFareOfflineReminderContent'), this.$t('Pricing.ECommerceFareOfflineReminder'), {
          confirmButtonText: this.$t('Pricing.OK'),
          cancelButtonText: this.$t('Pricing.CANCEL'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
        }).catch(() => {
          flag = true
        })
        if (flag) {
          return
        }
      }
      const { selectedRowUuids, price } = this
      if (selectedRowUuids.length > 0) {
        const markupsCost = [price.cost20, price.cost40, price.costHC, price.cost45, price.cost40nor, price.cost20nor]
        const markups1 = [price.one20, price.one40, price.oneHC, price.one45, price.one40nor, price.one20nor]
        const markups2 = [price.two20, price.two40, price.twoHC, price.two45, price.two40nor, price.two20nor]
        const markups3 = [price.three20, price.three40, price.threeHC, price.three45, price.three40nor, price.three20nor]
        const markupTypes = [price.oneMarkupType, price.twoMarkupType, price.threeMarkupType, price.costMarkupType]
        const params = [{
          level: price.level,
          priceFclUuids: selectedRowUuids,
          markupTypes: markupTypes,
          markupsCost: markupsCost,
          markupsTier1: markups1,
          markupsTier2: markups2,
          markupsTier3: markups3,
          isAsync: this.price.isAsync
        }]
        this.fullscreenLoading = getLoading()
        approvePriceFclsWithAllTiers(params).then(res => {
          this.$message.success(this.$t('Pricing.ManualAudit') + this.$t('Message.Success'))
          this.$emit('close')
          this.$emit('auditBack', this.selectedRows)
        }).finally(() => {
          this.fullscreenLoading.close()
        })
      }
    },
    onCancel() {
      this.$emit('close')
    },
    onReset() {
      PriceUtils.resetFilter(this.price)
      this.price.costMarkupType = true
      this.price.oneMarkupType = true
      this.price.twoMarkupType = true
      this.price.threeMarkupType = true
      this.price.level = '0'
    },
    onBlur(field) {
      this.price[field] = !this.price[field] ? 0 : this.price[field]
    }
  }
}
</script>

<style scoped>
  #app .cargo-number-input >>> input{
    text-align:right;
  }
  .row-top-5 {
    margin-top: 5px;
  }
</style>
